// The semi-colon before the function invocation is a safety 
// net against concatenated scripts and/or other plugins 
// that are not closed properly.
; (function ($, window, document, undefined) {

    // undefined is used here as the undefined global 
    // variable in ECMAScript 3 and is mutable (i.e. it can 
    // be changed by someone else). undefined isn't really 
    // being passed in so we can ensure that its value is 
    // truly undefined. In ES5, undefined can no longer be 
    // modified.

    // window and document are passed through as local 
    // variables rather than as globals, because this (slightly) 
    // quickens the resolution process and can be more 
    // efficiently minified (especially when both are 
    // regularly referenced in your plugin).

    // Create the defaults once
    var pluginName = 'interactivemap';
    var defaults = {
        apiBaseUrl: 'http://localhost:8000/api/interactivemap/',
        zoomMax: 300,
        zoomMin: 0,
        zoomInitial: 0,
        initialFilterCategories: [],
        initialFilterOpenStatus: 0
    };

    var keyCodes = {
        backspace: 8,
        tab: 9,
        enter: 13,
        shift: 16,
        ctrl: 17,
        alt: 18,
        esc: 27,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        del: 46
    };

    var delay = (function () {
        var timer = 0;
        return function (callback, ms) {
            clearTimeout(timer);
            timer = setTimeout(callback, ms);
        };
    })();

    // The actual plugin constructor
    function Plugin(element, options) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend({}, defaults, options);

        this._defaults = defaults;
        this._name = pluginName;
        this._keyCodes = keyCodes;

        this.init();
    }

    Plugin.prototype.init = function () {

        var $base = this;
        var $element = $base.$element;
        $base.element.type = 'interactivemap';

        $base.setMapSize();

        $('[data-toggle="tooltip"]').tooltip({
        	placement : 'top'
        })


        var initSmoothZoom = function() {
            $('.imapBackground', $element).smoothZoom({
                width: '100%',
                height: '100%',
                button_SIZE: 24,
                button_SIZE_TOUCH_DEVICE: 28,
                button_COLOR: '#FFFFFF',
                button_BG_COLOR: '#ffffff',
                button_BG_TRANSPARENCY: 60,
                button_ALIGN: "top right",
                button_ICON_IMAGE : "/ui/img/icons/icons.png",
                zoom_OUT_TO_FIT: "YES",
                button_AUTO_HIDE: false,
                button_AUTO_HIDE_DELAY: 2,
                container: '.imap',
                zoom_MAX: $base.options.zoomMax,
                zoom_MIN: $base.options.zoomMin,
                initial_ZOOM: $base.options.zoomInital,
                on_ZOOM_PAN_UPDATE: function (zoomData, success) {
                    setTimeout(function () {
                        $('.imapMenuFlyOut .flyOutWrapper', $element).slideUp('fast');

                        // Manually re-arrange z-indezes
                        //$('.imap .landmarks .item.mark', $element).each(function () {
                        //    var mark = $(this);

                        //    var elements = $('a', mark);
                        //    if (elements.length > 0) {
                        //        mark.css('z-index', 14);
                        //    } else {
                        //        mark.css('z-index', 13);
                        //    }
                        //});

                    }, 300);
                },
                on_IMAGE_LOAD: function () {

                },
                button_ROUND_CORNERS: false,
                responsive: false,
                responsive_maintain_ratio: false,
                max_WIDTH: '',
                max_HEIGHT: ''
            });
        };

        // Init the plugin
        initSmoothZoom();

        // Set initial open status filter if any
        if (!isNaN($base.options.initialFilterOpenStatus) && $base.options.initialFilterOpenStatus > 0) {
            $('li.openStatusButtons a[href="#' + $base.options.initialFilterOpenStatus + '"]', $element).addClass('selected');
        }

        // Set initial category filters if any
        if ($base.options.initialFilterCategories.length > 0) {

            // First select the root level categories in order to fetch child categories
            $('.imapMenu a[data-parentid="0"]', $element).each(function () {
                var button = $(this);
                var parentId = parseInt(button.attr('href').replace('#', ''));
                if ($.grep($base.options.initialFilterCategories, function(filter) { return filter.CategoryID === parentId; }).length === 0)
                    return true;
                
                // Fire the button to fetch its children and build flyout meny
                $base.toggleMenu(button, function () {
                    $base.toggleButtonLoader(button);

                    // Select only applicable children
                    if ($.grep($base.options.initialFilterCategories, function (filter) { return filter.ParentID === parentId; }).length > 0) {
                        var menu = $('.imapMenuFlyOut .flyOutWrapper[data-categoryid="' + parentId + '"] ul', $element).first();
                        $('li a', menu).each(function () {
                            var item = $(this);
                            item.removeClass('selected');
                            var categoryId = parseInt(item.attr('href').replace('#', ''));

                            if ($.grep($base.options.initialFilterCategories, function (filter) { return filter.CategoryID === categoryId; }).length === 0)
                                return true;

                            item.addClass('selected');
                        });
                    }
                    
                    $base.loadLandmarks(function () {
                        $base.toggleButtonLoader(button);
                    });
                });
            });
        }
        
        $('.imapMenu a, .imapMenuFlyOut a', $element).on('click', function (e) {
            $base.menuButtonClick($(this), e);
        });

        $('.windowSizeButton a', $element).on('click', function (e) {
            e.preventDefault();

            var button = $(this);

            button.toggleClass('maximized');
            $base.toggleFullscreen();
            $base.setMapSize();
        });

        $('#imapLandmarkModal').on('show.bs.modal', function (event) {
            var modal = $(this);
            var button = $(event.relatedTarget);
            var popupContent = $('.imapLandmarkPopupData ' + button.attr('href'));

            modal.find('.modal-title').html(button.text());
            modal.find('.modal-body').html(popupContent.html());
        });

        $(window).on('resize', function() {
            $base.setMapSize();
        });

		$(document).on('webkitfullscreenchange mozfullscreenchange fullscreenchange MSFullscreenChange', function(e){
			if (
				document.fullscreenElement ||
				document.webkitFullscreenElement ||
				document.mozFullScreenElement ||
				document.msFullscreenElement
			) {
				$base.$element.addClass('maximized')	
			}
			else {
				$base.$element.removeClass('maximized')
			}
			
		});
    };


    Plugin.prototype.toggleFullscreen = function(){
		if (
			document.fullscreenElement ||
			document.webkitFullscreenElement ||
			document.mozFullScreenElement ||
			document.msFullscreenElement
		) {
			this.$element.removeClass('maximized');

			if (document.exitFullscreen) {
				document.exitFullscreen();
			} else if (document.mozCancelFullScreen) {
				document.mozCancelFullScreen();
			} else if (document.webkitExitFullscreen) {
				document.webkitExitFullscreen();
			} else if (document.msExitFullscreen) {
				document.msExitFullscreen();
			}
		} else {
			this.$element.addClass('maximized');
			element = $('.imapContainer').get(0);

			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.mozRequestFullScreen) {
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				element.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
			} else if (element.msRequestFullscreen) {
				element.msRequestFullscreen();
			}
		}
    }
    
    Plugin.prototype.menuButtonClick = function (button, e) {
        var $base = this;

        e.preventDefault();

        $base.toggleMenu(button, function () {
            $base.toggleButtonLoader(button);
            $base.loadLandmarks(function () {
                $base.toggleButtonLoader(button);
            });
        });
    };

    Plugin.prototype.setMapSize = function () {
        var $base = this;
        var $element = $base.$element;

        var $container = $element.parent().parent();

    	if($element.hasClass('maximized'))
        {
 			var windowWidth = $(window).width();
        	var windowHeight = $(window).height();

        	var size = {width: windowWidth, height: windowHeight};
        	$element.css(size);
        	$('.imap', $element).css(size);

			if ($('.imapBackground', $element).data('smoothZoom')) {
				$('.imapBackground', $element).smoothZoom('resize', size);
			}

        	return;
        }

        if (!$container.is('div'))
            $container = $(window);

        var $menu = $('.imapMenu', $element);

        // Hide and reset sizes
        $('.imap', $element).hide().parent().css('height', '').css('width', '');
        $element.css('height', '').css('width', '');

        // Calculate size
        var containerSize = { width: $container.width(), height: $container.outerHeight() };
        var imapHeight = containerSize.height;
        console.log('containerSize', containerSize)
        console.log('$menu.height()', $menu.height())

        //if (containerSize.height === 0 || containerSize.height <= $menu.height()) {
            var $image = $('.imapBackground', $element);
            var imageSize = { width: $image.attr('data-originalwidth'), height: $image.attr('data-originalheight') };
            
            if (imageSize.width > containerSize.width) {
                var ratio = imageSize.height / imageSize.width;
                containerSize.height = Math.ceil(ratio * containerSize.width);
            }

            imapHeight = containerSize.height;
            containerSize.height += $menu.height();
        //} else {
         //   imapHeight -= $menu.height();
        //}
        
        // Set sizes and show
        //$element.height(containerSize.height + $menu.height() + 'px').width('100%');
        $element.height(containerSize.height + 'px').width('100%');
        $('.imap', $element).show().parent().height(imapHeight + 'px').width('100%');

       

        // If smoothzoom as been initialized, resize that aswell
        if ($('.imapBackground', $element).data('smoothZoom')) {
            $('.imapBackground', $element).smoothZoom('resize', { width: $('.imap', $element).parent().width(), height: $('.imap', $element).parent().height() });
        }

        return $base;
    };

    Plugin.prototype.toggleMenu = function (button, callback) {

        var $base = this;
        var $element = $base.$element;

        if (button.parents('li.openStatusButtons').length > 0) {
            button.toggleClass('selected');
            $base.loadLandmarks();
            return $base;
        }

        var categoryId = parseInt(button.attr('href').replace('#', ''));
        var parentId = parseInt(button.attr('data-parentid'));
        var flyout = $('.imapMenuFlyOut .flyOutWrapper[data-categoryid="' + categoryId + '"]', $element);
        var menu = parentId === 0 ? $('ul', flyout).first() : button.parents('ul').next('ul');

        if (button.hasClass('selected')) {
            // Deselect the category and all children
            button.removeClass('selected');
            
            if (parentId === 0) {
                flyout.hide();
                $('li a', menu).removeClass('selected');
            } else {
                $('li a', menu.nextAll('ul')).removeClass('selected').parents('ul').hide();
            }
            
            if ($.isFunction(callback))
                callback();

        } else {
            button.addClass('selected');
            
            if (parentId === 0) {
                // This is a rootlevel button.
                // Hide all other flyoutwrappers and add a wrapper to flyout for this button if not already present.
                $('.imapMenuFlyOut .flyOutWrapper', $element).hide();
                if (flyout.length === 0) {
                    flyout = $('<div class="flyOutWrapper" data-categoryid="' + categoryId + '"></div>').appendTo($('.imapMenuFlyOut', $element));
                }
            }

            // Get the active wrapper and try to get the next unordered list, add it if not existing
            if (menu.length === 0)
                menu = $('<ul class="clearfix"></ul>').appendTo(flyout);

            // Clear
            $('li a', menu).unbind('click');

            $.ajax({
                type: 'GET',
                url: $base.options.apiBaseUrl + 'categories/' + categoryId,
                data: null,
                contentType: 'application/json; charset=utf-8',
                dataType: 'json',
                async: true,
                success: function (data) {
                    if (data == null || data.length <= 0) {
                        if ($.isFunction(callback))
                            callback();

                        return;
                    }

                    var html = '';
                    $.each(data, function (index, item) {
                        if ($('li a[href="#' + item.id + '"]', menu).length > 0)
                            return true;

                        var style = item.categoryIconImage === '' ? '' : ' style="background-image:url(' + item.categoryIconImage + ');"';
                        html += '<li><a href="#' + item.id + '" data-positionsiconimageurl="' + item.positionsIconImage + '" data-parentid="' + item.parentID + '" data-openstatus="' + item.openStatusFlag + '"' + style + '>' + item.name + '</a></li>';
                    });

                    menu.append(html);

                    $('li a', menu).bind('click', function(e) {
                        $base.menuButtonClick($(this), e);
                    });

                    $('li a', menu).addClass('selected');
                    
                    flyout.show();

                    if ($.isFunction(callback))
                        callback();
                }
            });
        }
        
        return $base;
    }

    Plugin.prototype.toggleButtonLoader = function (button) {

        var $base = this;
        var $element = $base.$element;

        var loader = null;
        if (button.attr('data-parentid') === '0') {
            loader = button.siblings('div.ajaxloader');
        } else {
            loader = $('.imapMenu li a[href="#' + button.attr('data-parentid') + '"]', $element).siblings('div.ajaxloader');
        }

        if (loader.is(':visible')) {
            loader.hide();
        } else {
            loader.show();
        }

        return $base;
    }

    Plugin.prototype.loadLandmarks = function (callback) {

        var $base = this;
        var $element = $base.$element;

        var request = {
            categories: [],
            openStatusFlag: 0
        };
        
        // Get selected categories
        $('li:not(.openStatusButtons) a.selected', $element).each(function () {
            var categoryId = parseInt($(this).attr('href').replace('#', ''));
            var parentId = parseInt($(this).attr('data-parentid'));

            // Remove parents
            var parentIndex = $.inArray(parentId, request.categories);
            if (parentIndex > -1) {
                request.categories.splice(parentIndex, 1);    
            }
            
            request.categories.push(categoryId);
        });
        
        // Get selected open status
        $('li.openStatusButtons a.selected', $element).each(function () {
            request.openStatusFlag = request.openStatusFlag | parseInt($(this).attr('href').replace('#', ''));
        });
        
        $.ajax({
            type: 'POST',
            url: $base.options.apiBaseUrl + 'positions',
            data: JSON.stringify(request),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json',
            async: true,
            success: function (data) {

                $('.landmarks', $element).html('');
                $('.imapLandmarkPopupData', $element).html('');
                $element.smoothZoom('refreshAllLandmarks');

                if (data == null || data.length <= 0) {
                    if ($.isFunction(callback))
                        callback();

                    return;
                }

                console.log(data);

                $.each(data, function (index, item) {
                    var location = '';
                    location += '<div class="item mark" id="landmark' + item.id + '" data-parentid="' + item.parentID + '" data-position="' + item.x + ',' + item.y + '" data-show-at-zoom="0" data-allow-scale="' + item.allowScaling + '" data-pos-top-left="' + item.positionIsTopLeft + '">';

                    if (item.image !== '') {
                        location += '<div class="label"></div>';
                        if (item.popupContent !== '') {
                            location += '<a href="#landmarkPopup' + item.id + '"" title="' + item.name + '" class="landmarkButton">';
                            location += '<img src="' + item.image + '" alt="' + item.name + '" />';
                            location += '</a>';
                        } else {
                            location += '<img src="' + item.image + '" alt="' + item.name + '" />';
                        }
                    } else {
                        location += '<div class="label">';

                        if (item.PopupContent !== '')
                            location += '<a href="#landmarkPopup' + item.id + '" data-toggle="modal" data-target="#imapLandmarkModal" title="' + item.name + '" class="landmarkButton">';

                        var category = $('a[href="#' + item.parentID + '"]', $element);
                        if (category) {
                            var categoryIcon = category.attr('data-positionsiconimageurl');
                            if (categoryIcon && categoryIcon.length > 0)
                                location += '<img src="' + categoryIcon + '" alt="' + item.name + '" style="width: 20px; height: 20px;"/>';
                        }

                        if (item.label !== '')
                            location += '<span>' + item.label + '</span>';

                        if (item.popupContent !== '')
                            location += '</a>';

                        location += '</div>';
                    }

                    location += '</div>';

                    $('.landmarks', $element).append(location);
                    
                    if (item.PopupContent !== '') {


                       $('<div id="landmarkPopup' + item.id + '" class="landmarkPopup">' + item.popupContent + '</div>').appendTo($('.imapLandmarkPopupData'));
                    }
                });

                $('.imapBackground', $element).smoothZoom('refreshAllLandmarks');

                // Manually re-arrange z-indezes
                //var categoryId = 0;
                //var zindex = 12;

                $('.landmarks .item.mark', $element).each(function () {
                    var $mark = $(this);

                    //if (parseInt($mark.attr('data-parentid')) !== categoryId) {
                    //    categoryId = parseInt($mark.attr('data-parentid'));
                    //    zindex++;
                    //}

                    //$mark.css('z-index', zindex);

                    var clickable = $('a', $mark);
                    if (clickable.length > 0) {
                        $mark.css('z-index', 15);
                        return true;
                    }

                    var label = $('div.label img', $mark);
                    if (label.length > 0) {
                        $mark.css('z-index', 14);
                        return true;
                    }
                    
                    $mark.css('z-index', 13);
                });

                $('.landmarkButton', $element).unbind('click');
                $('.landmarkButton', $element).bind('click', function(e) {
                    e.preventDefault();
                });

                if ($.isFunction(callback))
                    callback();
            }
        });

        return $base;
    };
    

    // A really lightweight plugin wrapper around the constructor, 
    // preventing against multiple instantiations
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, pluginName)) {
                $.data(this, pluginName, new Plugin(this, options));
            }
        });
    };
})(jQuery, window, document);